export const internalGlobalObjectKey = '_faroInternal';
